import { useMemo, memo } from "react";
import { List, useRecordContext, Pagination } from "react-admin";
import { Typography } from "@mui/material";
import RecipientsListContent from "./RecipientsListContent";
import { getBroadcastStatusPollIntervalMs } from "./broadcast-polling";

const RecipientsList = memo(() => {
  const record = useRecordContext();
  const broadcastId = record?.id;
  const pollIntervalMs = getBroadcastStatusPollIntervalMs(record?.status as string | undefined);

  const listProps = useMemo(
    () => ({
      resource: "whatsappBroadcastRecipients" as const,
      filter: { broadcastId: broadcastId as string | number },
      perPage: 25,
      sort: { field: "sentAt", order: "DESC" as const },
      pagination: <Pagination />,
      actions: false as const,
      title: "" as const,
      queryOptions: { refetchInterval: pollIntervalMs },
    }),
    [broadcastId, pollIntervalMs]
  );

  if (!broadcastId) {
    return <Typography>No broadcast selected</Typography>;
  }

  return (
    <List {...listProps}>
      <RecipientsListContent broadcastRecord={record} />
    </List>
  );
});
RecipientsList.displayName = "RecipientsList";

export default RecipientsList;
